import React from "react";
function Pic() {
  return (
    <div className="pics-container">
      <h2>Celebrate Love in Style – Exclusive Wedding Collection</h2>

      <div className="image-gallery">
        <img
          src="https://www.shaadidukaan.com/vogue/wp-content/uploads/2020/01/amritphotography.jpg"
          alt="Wedding Outfit 1"
          className="fade-in"
        />
        <img
          src="https://media.istockphoto.com/id/866987706/photo/indian-wedding-hands.jpg?s=612x612&w=0&k=20&c=6L-u9qhFPv9MjDnF4UK4AqjVbDKM4_8Xad72IHhwPZE="
          alt="Wedding Outfit 2"
          className="fade-in"
        />
        <img
          src="https://i.pinimg.com/236x/18/85/84/1885845cfbe5e7d34a3f445f61891ad3.jpg"
          alt="Wedding Outfit 3"
          className="fade-in"
        />
        <img
          src="https://media-api.xogrp.com/images/f4570601-a1e6-4802-86fb-ad9e988066fe~rs_768.h"
          alt="Wedding Outfit 4"
          className="fade-in"
        />
      </div>

      <div className="card-gallery">
        <div className="info-card">
          <h3>Bridal Elegance</h3>
          <p>Timeless designs with luxurious fabrics and intricate embroidery.</p>
        </div>
        <div className="info-card">
          <h3>Groom’s Royal Look</h3>
          <p>Classic sherwanis and modern styles for the perfect wedding look.</p>
        </div>
        <div className="info-card">
          <h3>Couple’s Coordination</h3>
          <p>Matching wedding outfits for a stunning, harmonious look.</p>
        </div>
        <div className="info-card">
          <h3>Luxury Accessories</h3>
          <p>Handpicked accessories to complete your wedding ensemble.</p>
        </div>
      </div>
    </div>
  );
}

export default Pic;
